module.exports = __webpack_public_path__ + "img/201910.7ce15fc5.png";